export interface RecCatalogDto {
  data: RecContentItemDto[];
  included: RecTaxonomyNodeDto[];
}

export interface RecJsonApiDataItem {
  id: string;
  type: string;
}

export interface RecJsonApiData {
  links?: {};
  data: RecJsonApiDataItem[];
  meta?: {};
}

export interface RecTaxonomyNodeRelationshipsDto {
  children: RecJsonApiData;
}

export enum RecTaxonomyNodeAttributesNodeTypeDto {
  CHAPTER = 'CHAPTER',
  BOOK = 'BOOK'
}

export interface RecTaxonomyNodeAttributesDto {
  id: string;
  vtwId: string;
  level: number;
  displayName: string;
  displayOrder: number;
  text: string;
  leaf: boolean;
  root: boolean;
  nodeType: RecTaxonomyNodeAttributesNodeTypeDto;
}

export interface RecTaxonomyNodeDto {
  id: string;
  type: string;
  attributes: Partial<RecTaxonomyNodeAttributesDto>;
  relationships: Partial<RecTaxonomyNodeRelationshipsDto>;
}

export interface RecContentItemTaxonomyNodeDto {
  id: string;
  type: string;
}

export interface RecContentItemAttributesDto {
  contentId: string;
  isbn: string;
  displayName: string;
  isPublished: boolean;
  publishDate: string; // 2022-05-22T00:00:00.000UTC
  active: boolean;
}

export interface RecContentItemRelationshipsDto {
  taxonomies: RecJsonApiData;
}

export interface RecContentItemDto {
  type: RecContentItemTypeDto;
  id: string;
  attributes: Partial<RecContentItemAttributesDto>;
  relationships: Partial<RecContentItemRelationshipsDto>;
}

export enum RecContentItemTypeDto {
  ADAPTIVE_LESSON = 'ADAPTIVE_LESSON',
  EBOOK_READING = 'EBOOK_READING',
  EVOLVE_RESOURCE = 'EVOLVE_RESOURCE',
  SHERPATH_LESSON = 'SHERPATH_LESSON',
  SHERPATH_SKILL = 'SHERPATH_SKILL',
  SHERPATH_SIMULATION = 'SHERPATH_SIMULATION',
  SIM_CHART = 'SIM_CHART',
  QUESTION = 'QUESTION', // This is for EAQ and EL questions and should never be represented on the course plan as an item
  HESI_EXAM = 'HESI_EXAM',
  HESI_ASSESS = 'HESI_ASSESS',
  SHADOW_HEALTH = 'SHADOW_HEALTH',
  SHERPATH_MODULE = 'SHERPATH_MODULE',
  SHERPATH_POWERPOINT = 'SHERPATH_POWERPOINT',
  SHERPATH_GROUP_ACTIVITY = 'SHERPATH_GROUP_ACTIVITY',
  SHERPATH_CASE_STUDY = 'SHERPATH_CASE_STUDY',
  OSMOSIS_VIDEO = 'OSMOSIS_VIDEO',
  SHERPATH_TESTBANK = 'SHERPATH_TESTBANK',
  REVIEW_QUIZ = 'REVIEW_QUIZ',
  ACKNOWLEDGEMENTS = 'ACKNOWLEDGEMENTS',
  COURSE_UPDATES = 'COURSE_UPDATES',
  SCENARIO_INDEX = 'SCENARIO_INDEX',
  IMPLEMENTATION_GUIDE = 'IMPLEMENTATION_GUIDE',
  READING_ASSIGNMENT = 'READING_ASSIGNMENT',
  VERBAL_REPORT_TEMPLATE = 'VERBAL_REPORT_TEMPLATE',
  OBSERVER_EVALUATION_RUBRIC = 'OBSERVER_EVALUATION_RUBRIC',
  MOULAGE_MANUAL = 'MOULAGE_MANUAL',
  PATIENT_REPORT = 'PATIENT_REPORT',
  LAB_SIMULATION_IMPLEMENTATION_MODULE = 'LAB_SIMULATION_IMPLEMENTATION_MODULE',
  VR_SIMULATION_IMPLEMENTATION_MODULE = 'VR_SIMULATION_IMPLEMENTATION_MODULE',
  VR_SIMULATION = 'VR_SIMULATION',
  SLS_SIMCHART_SIMULATION_EHR = 'SLS_SIMCHART_SIMULATION_EHR',
  PRE_SIMULATION_QUIZ = 'PRE_SIMULATION_QUIZ',
  POST_SIMULATION_QUIZ = 'POST_SIMULATION_QUIZ',
  SCMO_NG = 'SCMO_NG',
  PRE_SIMULATION_EXERCISE = 'PRE_SIMULATION_EXERCISE',
  POST_SIMULATION_EXERCISE = 'POST_SIMULATION_EXERCISE',
  JOURNAL_EXERCISE = 'JOURNAL_EXERCISE',
  SBAR_EXERCISE = 'SBAR_EXERCISE',
  PERFORMANCE_CHECKLIST = 'PERFORMANCE_CHECKLIST'
}

export const SimulationLearningSystemRecContentTypeDto: RecContentItemTypeDto[] = [
  RecContentItemTypeDto.ACKNOWLEDGEMENTS,
  RecContentItemTypeDto.READING_ASSIGNMENT,
  RecContentItemTypeDto.VERBAL_REPORT_TEMPLATE,
  RecContentItemTypeDto.OBSERVER_EVALUATION_RUBRIC,
  RecContentItemTypeDto.COURSE_UPDATES,
  RecContentItemTypeDto.SCENARIO_INDEX,
  RecContentItemTypeDto.IMPLEMENTATION_GUIDE,
  RecContentItemTypeDto.MOULAGE_MANUAL,
  RecContentItemTypeDto.PRE_SIMULATION_QUIZ,
  RecContentItemTypeDto.POST_SIMULATION_QUIZ,
  RecContentItemTypeDto.PATIENT_REPORT,
  RecContentItemTypeDto.LAB_SIMULATION_IMPLEMENTATION_MODULE,
  RecContentItemTypeDto.VR_SIMULATION_IMPLEMENTATION_MODULE,
  RecContentItemTypeDto.VR_SIMULATION,
  RecContentItemTypeDto.SLS_SIMCHART_SIMULATION_EHR,
  RecContentItemTypeDto.PRE_SIMULATION_EXERCISE,
  RecContentItemTypeDto.POST_SIMULATION_EXERCISE,
  RecContentItemTypeDto.JOURNAL_EXERCISE,
  RecContentItemTypeDto.SBAR_EXERCISE,
  RecContentItemTypeDto.PERFORMANCE_CHECKLIST
];

export const CoursewareSupportedRecContentItems = [
  RecContentItemTypeDto.ADAPTIVE_LESSON,
  RecContentItemTypeDto.EVOLVE_RESOURCE,
  RecContentItemTypeDto.SHERPATH_LESSON,
  RecContentItemTypeDto.SHERPATH_SIMULATION,
  RecContentItemTypeDto.SHERPATH_SKILL,
  RecContentItemTypeDto.SIM_CHART,
  RecContentItemTypeDto.EBOOK_READING,
  RecContentItemTypeDto.HESI_EXAM,
  RecContentItemTypeDto.HESI_ASSESS,
  RecContentItemTypeDto.SHADOW_HEALTH,
  RecContentItemTypeDto.SHERPATH_MODULE,
  RecContentItemTypeDto.SHERPATH_POWERPOINT,
  RecContentItemTypeDto.SHERPATH_GROUP_ACTIVITY,
  RecContentItemTypeDto.SHERPATH_CASE_STUDY,
  RecContentItemTypeDto.OSMOSIS_VIDEO,
  RecContentItemTypeDto.SHERPATH_TESTBANK,
  RecContentItemTypeDto.REVIEW_QUIZ,
  RecContentItemTypeDto.SCMO_NG,
  ...SimulationLearningSystemRecContentTypeDto
];
